import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ClientApp from './ClientApp';
import './utils/fontAwesome';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Routes>
        <Route path="/*" element={<ClientApp />} />
      </Routes>
    </HelmetProvider>
  );
};

export default App;